module.exports = __webpack_public_path__ + "media/svg-new/f-file-cb58ae9c.svg";